'use strict';

module.exports = function thunkMiddlewear(store) {
	return function (nextDispatch) {
		return function (action) {
			return typeof action === 'function' ? action(store.dispatch, store.getState) : nextDispatch(action);
		};
	};
};
